// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Jf6d","footer":"ModalError_footer__GWZZB"};